import { sendSocketMessage, socketMessageStream } from "./socketStream";
import { first, map, timeout } from "rxjs/operators";
import { generateRandomId } from "./session";

let instance = null;

class CoPilot {
    constructor() {}

    static getInstance() {
        if (instance === null) {
            instance = new CoPilot();
        }
        return instance;
    }

    async fixGrammar(message) {
        const id = generateRandomId();
        sendSocketMessage("copilot fix-grammar", { message, id });
        return socketMessageStream
            .pipe(
                first((message) => message.cmd === "copilot_response" && message.data.id === id),
                map((message) => message.data.result),
                timeout(10000)
            )
            .toPromise();
    }

    async longSentence(message) {
        const id = generateRandomId();
        sendSocketMessage("copilot long-sentence", { message, id });
        return socketMessageStream
            .pipe(
                first((message) => message.cmd === "copilot_response" && message.data.id === id),
                map((message) => message.data.result),
                timeout(10000)
            )
            .toPromise();
    }

    async changeTone(message, tone) {
        const id = generateRandomId();
        sendSocketMessage("copilot change-tone", { message, id, tone });
        return socketMessageStream
            .pipe(
                first((message) => message.cmd === "copilot_response" && message.data.id === id),
                map((message) => message.data.result),
                timeout(10000)
            )
            .toPromise();
    }

    async recommendAnswer(siteId, userId, conversationId) {
        console.log("recommendAnswer", { siteId, userId, conversationId });
        const id = generateRandomId();
        sendSocketMessage("copilot recommend-answer", { siteId, userId, conversationId, id });
        return socketMessageStream
            .pipe(
                first((message) => message.cmd === "copilot_response" && message.data.id === id),
                map((message) => message.data.result),
                timeout(10000)
            )
            .toPromise();
    }

    async messageTranslation(message, languageCode) {
        const id = generateRandomId();
        sendSocketMessage("copilot message-translation", { message, languageCode, id });
        return socketMessageStream
            .pipe(
                first((message) => message.cmd === "copilot_response" && message.data.id === id),
                map((message) => message.data.result),
                timeout(10000),
            )
            .toPromise();
    }
    async promptToGenerateResponse(message) {
        const id = generateRandomId();
        sendSocketMessage("copilot prompt-to-generate-response", { message, id });
        return socketMessageStream
            .pipe(
                first((message) => message.cmd === "copilot_response" && message.data.id === id),
                map((message) => message.data.result),
                timeout(10000),
            )
            .toPromise();
    }
}

export default CoPilot;
